/**
 * Regras puras da página /sistema/ml-afiliados — Mercado Livre, cobertura de afiliados.
 *
 * Workflow MANUAL oficial (não existe API pública do ML para gerar link de afiliado):
 * lote priorizado -> Gerador de Links do Portal -> preview -> import explícito.
 * Nada aqui gera, completa ou "conserta" link: a página só exibe o que a API classificou.
 */
export const ROTA_API = '/ml-affiliate-links/workflow';
export const TAMANHOS_LOTE = [10, 20, 30, 50];
export const LOTE_PADRAO = 30;
export const ETIQUETA_PADRAO = 'supervitrineofertas';
// Página pública oficial do programa (o Gerador de Links fica dentro do Portal, logado).
export const PORTAL_URL = 'https://www.mercadolivre.com.br/l/afiliados-portal-do-afiliado';

export const STATUS_PREVIEW = {
    VALID: { label: 'Válido', cls: 'sv-badge-success' },
    INVALID: { label: 'Inválido', cls: 'sv-badge-danger' },
    DUPLICATE: { label: 'Duplicado', cls: 'sv-badge-muted' },
    CONFLICT: { label: 'Conflito', cls: 'sv-badge-warning' },
    UNMATCHED: { label: 'Sem correspondência', cls: 'sv-badge-warning' },
    ALREADY_COVERED: { label: 'Já coberto', cls: 'sv-badge-muted' },
    // Não é conflito: o Portal recusou o produto. Cooldown de 14 dias, depois só tentativa manual.
    PORTAL_REFUSED: { label: 'Recusado pelo Portal', cls: 'sv-badge-muted' },
};

export const dataCurta = (iso) => (iso ? String(iso).slice(0, 10) : '—');

export const TIERS = {
    f1_provavel: 'Provável F1',
    evergreen: 'Evergreen',
    elegivel: 'Elegível',
    catalogo: 'Catálogo',
};

export const PASSOS = [
    'Baixe ou copie o lote (TXT: uma URL por linha).',
    'Abra o Gerador de Links no Portal de Afiliados do Mercado Livre (computador, logado).',
    'Cole as URLs.',
    'Gere os links.',
    'Copie o resultado mantendo o produto e o link na MESMA linha (ou preencha a coluna affiliate_url do CSV do lote).',
    'Cole ou envie aqui, confira o preview e importe só os válidos.',
];

export const pct = (v) => (v === null || v === undefined ? '—' : `${Number(v).toFixed(1)}%`);

export const coberturaBaixa = (resumo) => Boolean(resumo && resumo.alert && resumo.alert.low_coverage);

export const nomeArquivo = (lotId, ext) => `ml-lote-${String(lotId || 'sem-id').replace(/[^A-Za-z0-9_-]/g, '')}.${ext}`;

export const tamanhoValido = (n) => TAMANHOS_LOTE.includes(Number(n));

/** Só as linhas VALID podem ser importadas; nada mais é enviado ao import além do preview_id. */
export const importaveis = (preview) => (preview && preview.resumo ? Number(preview.resumo.VALID || 0) : 0);

export const podeImportar = (preview, importado) => Boolean(preview && preview.preview_id && !importado && importaveis(preview) > 0);

export const contagemPreview = (preview) => Object.keys(STATUS_PREVIEW).map((k) => ({
    status: k, label: STATUS_PREVIEW[k].label, n: Number((preview && preview.resumo && preview.resumo[k]) || 0),
}));

export const idadeSnapshot = (snap) => {
    if (!snap || !snap.present) return 'sem snapshot do worker';
    const m = snap.age_minutes;
    if (m === null || m === undefined) return 'snapshot sem data';
    return m < 1 ? 'atualizado agora' : `atualizado há ${m} min`;
};

export const simNao = (v) => (v ? 'SIM' : 'NÃO');

export const META_MONETIZAVEL = 95;

/**
 * Cobertura dos elegíveis ML. Bruta = official / todos. Operacional (monetizable_coverage) =
 * official / (official + missing): portal_refused sai do denominador porque o Programa não permite
 * monetizar esses produtos hoje. As duas são mostradas; nada é escondido.
 */
export const coberturaElegiveis = (el) => {
    const e = el || {};
    const official = Number(e.with_affiliate || 0);
    const refused = Number(e.portal_refused || 0);
    const missing = e.missing !== undefined ? Number(e.missing) : Math.max(0, Number(e.without_affiliate || 0) - refused);
    const total = Number(e.total || 0);
    const r1 = (n, d) => (d > 0 ? Math.round((1000 * n) / d) / 10 : null);
    return { total, official, refused, missing, bruta: r1(official, total), monetizavel: r1(official, official + missing) };
};

/** Alertas do watch de cobertura (informativos: o hard gate já impede publicar sem afiliado). */
export const alertasCobertura = (c) => {
    const out = [];
    if (c.monetizavel !== null && c.monetizavel < META_MONETIZAVEL) {
        out.push({ nivel: 'forte', texto: `Cobertura operacional abaixo de ${META_MONETIZAVEL}%: ${pct(c.monetizavel)}` });
    }
    if (c.missing > 0) out.push({ nivel: 'aviso', texto: 'Existem produtos elegíveis aguardando geração de link afiliado.' });
    return out;
};
